<template>
  <a-modal
    :visible="visible"
    title="驳回"
    :confirm-loading="isConfirmCloseBtnLading"
    @ok="handleReject"
    @cancel="handleCancelClose"
  >
    <a-textarea placeholder="请填写驳回备注" v-model="closeReason" :maxLength="200" :auto-size="{ minRows: 3, maxRows: 6 }" />
  </a-modal>
</template>

<script>
import { apiGetAppRejectAppts } from '@/api/scp/materialReservationManagement/materialReservation'

export default {
  name: 'RejectModal',
  data () {
    return {
      visible: false,
      isConfirmCloseBtnLading: false,
      closeReason: '',
      selectedData: [] // 勾选的数据
    }
  },
  methods: {
    show (data) {
      this.selectedData = data
      this.visible = true
      this.closeReason = ''
    },
    // 驳回
    handleReject () {
      this.isConfirmCloseBtnLading = true
      const apptsNoList = this.selectedData.map(item => item.apptsNo)
      apiGetAppRejectAppts({ apptsNoList: apptsNoList, remark: this.closeReason }).then(res => {
        if (res?.code === 200) {
          this.$message.success('操作成功')
          this.$emit('closeModal')
          this.visible = false
        }
      }).finally(() => {
        this.isConfirmCloseBtnLading = false
      })
    },
    // 取消
    handleCancelClose () {
      this.visible = false
      this.closeReason = ''
    }
  }
}
</script>

<style scoped>

</style>
